if (!customElements.get('size-guide-drawer')) {
  class SkinnySizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sizeGuideReady === 'true') return;

      this.trigger = this.querySelector('[aria-haspopup="dialog"]');
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-size-guide-close]');
      this.tabs = Array.from(this.querySelectorAll('[data-size-guide-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-size-guide-panel]'));

      if (!this.trigger || !this.dialog || !this.closeButton) return;

      this.dataset.sizeGuideReady = 'true';
      this.trigger.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event));
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('close', () => this.handleClose());
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.sizeGuideTab));
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
      });
    }

    open() {
      this.previouslyFocused = document.activeElement;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('sh-size-guide-lock');
      requestAnimationFrame(() => this.dialog.focus({ preventScroll: true }));
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    handleClose() {
      this.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('sh-size-guide-lock');

      const focusTarget = this.previouslyFocused?.isConnected ? this.previouslyFocused : this.trigger;
      focusTarget?.focus();
    }

    handleBackdropClick(event) {
      if (event.target !== this.dialog) return;

      const bounds = this.dialog.getBoundingClientRect();
      const isOutside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (isOutside) this.close();
    }

    selectTab(unit) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.sizeGuideTab === unit;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.sizeGuidePanel !== unit;
      });
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      const nextTab = this.tabs[nextIndex];
      this.selectTab(nextTab.dataset.sizeGuideTab);
      nextTab.focus();
    }
  }

  customElements.define('size-guide-drawer', SkinnySizeGuideDrawer);
}
